import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_PERMISSIONS } from './constants';

export const getPermissions = extendRoutine(createRoutine(GET_PERMISSIONS), 'RESET');
